// src/components/AdminSideComponents/packages/PackageDeleteConfirm.jsx
import React from "react";
import { X, AlertTriangle } from "lucide-react";

const PackageDeleteConfirm = ({ isOpen, onClose, packageData, onConfirm }) => {
  if (!isOpen || !packageData) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-md rounded-xl shadow-2xl overflow-hidden"
      >
        <div className="p-6 border-b bg-red-50">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-8 h-8 text-red-600" />
            <h3 className="text-xl font-bold text-red-800">
              Delete Package?
            </h3>
          </div>
        </div>

        <div className="p-6 space-y-6">
          <p className="text-gray-700">
            You are about to permanently delete:
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <h4 className="font-semibold text-lg text-gray-800 mb-1">
              {packageData.name}
            </h4>
            <p className="text-sm text-gray-600">
              {packageData.category} • ₹
              {packageData.discountedPrice || packageData.price}
            </p>
          </div>

          <p className="text-red-600 font-medium text-sm">
            This action cannot be undone. All associated data will be lost.
          </p>

          <div className="flex justify-end gap-4">
            <button
              onClick={onClose}
              className="px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition font-medium"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition flex items-center gap-2"
            >
              <AlertTriangle size={18} />
              Delete Package
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageDeleteConfirm;